export default __webpack_public_path__ + "static/media/gw200-5.2775bab6.png";